/* eslint-disable no-underscore-dangle */
import { registerHandler } from "../handler";
import { loadTVSquared } from "src/vendor/tvsquared";

// Owned by offline marketing team. PoC: Greg Kapp
export default function registerHandlers() {
  registerHandler("init", async () => {
    const _tvq = await loadTVSquared();
    _tvq.push([
      function deleteVars() {
        this.deleteCustomVariable(5, "page");
      },
    ]);
    _tvq.push(["trackPageView"]);
  });
  registerHandler("purchase", async ({ order, promoCode }) => {
    const _tvq = await loadTVSquared();

    triggerAction(_tvq, "purchasecompletion", {
      rev: order.eltv_13_months,
      promo: promoCode,
    });
  });
}

function triggerAction(
  _tvq: Awaited<ReturnType<typeof loadTVSquared>>,
  actionName: string,
  action: Record<string, unknown>
) {
  _tvq.push([
    function setVariable() {
      this.setCustomVariable(5, actionName, JSON.stringify(action), "page");
    },
  ]);
  _tvq.push(["trackPageView"]);
}
